export default __webpack_public_path__ + "static/media/hazard_harm.fb40ea41.png";